import styled from 'styled-components/macro'
import palette from 'src/designSystem/variables/palette'
import { P } from 'src/components/Reusable/Text/Text.styles'
import { DropdownToggleButton } from 'src/components/Reusable/Buttons/DropdownToggleButton/DropdownToggleButton'
import { FieldLabel } from 'src/components/ModalForms/ModalForm.styles'
import { ReactComponent as eroSVG } from 'src/components/Icons/Brand/ero_dark.svg'
import { ReactComponent as DeleteSVG } from 'src/components/Icons/assets/delete-icon.svg'
import { ReactComponent as AddSVG } from 'src/components/Icons/assets/add-icon.svg'
import { ReactComponent as ArrowSVG } from 'src/components/Icons/Basic/icons_arrow.svg'

export const TrustPortalContentContainer = styled.div`
  display: flex;
  flex-direction: column;
  margin-top: 16px;
  padding: 0 24px;
`

export const TrustPortalOverview = styled.div`
  display: flex;
  flex-direction: column;
  gap: 4px;
`

export const TabContentContainer = styled.div<{
  $noHorizontalPadding?: boolean
}>`
  display: flex;
  flex-direction: column;
  padding: ${({ $noHorizontalPadding }) =>
    $noHorizontalPadding ? '0 0 24px 0' : '0px 24px 24px'};
`

export const TabContentHeader = styled.div<{ $row?: boolean }>`
  display: flex;
  flex-direction: ${({ $row }) => ($row ? 'row' : 'column')};
  justify-content: space-between;
  align-items: center;
  gap: 8px;
  margin-top: ${({ $row }) => ($row ? '8px' : '0')};
`

export const GridContainer = styled.div`
  display: flex;
  flex-direction: column;
  margin-top: 24px;
  white-space: nowrap;
  flex-grow: 1;
  width: 100%;
`

export const MenuItemText = styled(P)`
  color: ${palette.neutral[900]};
  cursor: pointer;
  font-weight: 500;
  font-size: 14px;
  width: 100%;
`

export const WarningText = styled(MenuItemText)`
  color: ${palette.orange[900]};
`
export const WarningTextAction = styled(WarningText)`
  cursor: pointer;
  text-decoration: underline;
`

export const DropdownButton = styled(DropdownToggleButton)`
  width: 100%;
`

export const StyledFieldLabel = styled(FieldLabel)`
  font-size: 14px;
  gap: 2px;
  display: flex;
  flex-direction: column;
  width: 100%;
  > div {
    margin: 0;
  }
`
export const ControlObjectiveEditContainer = styled.div`
  position: relative;
  display: flex;
  flex-direction: column;
  height: 100%;
  gap: 8px;
  & .react-mde {
    height: 100%;
    display: flex;
    flex-direction: column;
    border-radius: 8px;
    & .mde-header {
      display: flex;
      align-items: center;
      background: none;
      border-top: 1px solid ${palette.neutral[100]};
      & .mde-header-group {
        border-left: 1px solid ${palette.neutral[100]};
      }
    }
    & :nth-of-type(2) {
      height: 100%;
      & .mde-textarea-wrapper {
        height: 100%;
        & textarea {
          &:focus-visible {
            outline: none;
          }
      }
    }
  }
`

export const EroIcon = styled(eroSVG)<{
  $width?: number
  $height?: number
}>`
  width: ${({ $width }) => ($width ? `${$width}px` : '24px')};
  height: ${({ $height }) => ($height ? `${$height}px` : '24px')};
  cursor: pointer;
`
export const ModalFormLabel = styled.label`
  display: flex;
  gap: 8px;
  justify-content: space-between;
  font-weight: 400;
  font-size: 14px;
  line-height: 150%;
`
export const ModalDescription = styled.p`
  font-weight: 400;
  font-size: 14px;
  line-height: 150%;
  color: ${palette.neutral[900]};
`

export const DeleteIcon = styled(DeleteSVG)`
  width: 32px;
  height: 32px;
  cursor: pointer;
`

export const AddIcon = styled(AddSVG)`
  width: 32px;
  height: 32px;
  cursor: pointer;
`

export const ArrowIcon = styled(ArrowSVG).attrs<{ direction?: 'up' | 'down' }>(
  (props) => ({
    direction: props.direction || 'up',
  }),
)`
  width: 32px;
  height: 32px;
  cursor: pointer;
  transform: rotate(
    ${(props) => (props.direction === 'up' ? '0deg' : '180deg')}
  );
`

export const ButtonContainer = styled.div`
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 10px;
  & button {
    margin: 0 !important;
  }
`
